// extracted by mini-css-extract-plugin
export default {"container":"Wo-z","ratingLayout":"Xo-z","ratingLabel":"Yo-z","nonInteractiveRatingLabel":"Zo-z"};